import types from '../constants/documentConstants';

const initialState = {
  active_notification: [],
};

const docReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_DOCTITLE:
      return {
        ...state,
        title: action.payload,
        error: null,
      };
    case types.SET_DOCFILE:
      return {
        ...state,
        file: action.payload,
      };
    case types.SET_ACTIVE_NOTIFICATION:
      return {
        ...state,
        active_notification: action.payload,
      };
    case types.APPEND_ACTIVE_NOTIFICATION: {
      const item = action.payload;
      if (item == null || typeof item !== 'object') {
        return state;
      }
      return {
        ...state,
        active_notification: [...(state.active_notification || []), item],
      };
    }
    case types.SET_DOC_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case types.SET_ERR:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default docReducer;
